export default "__VITE_ASSET__CfDdhroL__"